<template>
  <div class="index" v-cloak>
    <div class="cate-container" v-if="parent_list.length > 0">
      <div class="parent-box">
        <div class="parent-btn iconfont icon-xiangxia" @click="show_parent = !show_parent"></div>
        <div class="parent-cate">
          <div class="parent-item" :class="i.id == parent_id ? 'active' : ''" v-for="i in parent_list"
            @click="chooseParent(i.id)">{{ i.title }}</div>
        </div>
      </div>
      <template v-for="(cate_children, children_idx) in child_lists">
        <div class="child-list">
          <div class="child-item" :class="child_ids[children_idx] == cate_child.id ? 'active' : ''"
            @click="chooseChild(cate_child.id, children_idx)" v-for="cate_child in cate_children">{{ cate_child.title }}
          </div>
        </div>
      </template>
    </div>
    <!-- parent-window -->
    <div class="mask" v-if="show_parent" @click="show_parent = !show_parent"></div>
    <div class="parent-window" v-if="show_parent">
      <div class="parent-item" :class="i.id == parent_id ? 'active' : ''" v-for="i in parent_list" @click="chooseParent(i.id)">{{ i.title }}</div>
    </div>
    <div class="news-list" v-if="articleList.length > 0">
      <div class="news-item" v-for="i in articleList" @click="goDetail(i.id)">
        <div class="acea-row row-column row-between">
          <div class="news-title omit2">{{ i.title }}</div>
          <div class="news-synopsis omit1">{{ i.synopsis || '--' }}</div>
          <div class="news-time">{{ i.add_time }}</div>
        </div>
        <div class="news-img">
          <img :src="i.image_input[0]" alt="">
        </div>
      </div>
    </div>
    <div class="nodata" v-else>
      --暂无内容--
    </div>
    <!-- 分页 -->
    <div class="page-content">
      <div class="iconfont icon-xiangzuo" @click="prePage"></div>
      <div class="page_number"><span style="color:#ff0000">{{ page }}</span><span style="margin:0 .2rem">/</span>{{
        page_count }}</div>
      <div class="iconfont icon-xiangyou" @click="nextPage"></div>
    </div>
    <!-- 底部占高 -->
    <div class="index-botom" style="height: 1rem"></div>

  </div>
</template>

<script>
import { getArticleList, getFulianCate } from "@api/public";
import debounce from "lodash.debounce";
export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
      pid: 0, //分类id
      parent_list: [],
      parent_id: 0,
      child_lists: [],
      child_ids: [],
      show_parent: false,

      articleList: [],
      page: 1,
      page_count: 1,
      limit: 10,

    };
  },
  watch: {
    parent_id(val) {
      this.getChildList(val);
    },
    child_ids(val) {
      this.getArticleList()
    },
  },
  mounted: function () {
    let that = this;
    that.pid = that.$route.query.pid;
    that.getFulianCate();
  },
  methods: {
    async getFulianCate() {
      let that = this;
      let pid = this.pid;
      getFulianCate(pid).then(async (res) => {
        let list = res.data;
        if(list.length <= 0){
          this.getArticleList()
        }else{
          this.parent_list = list,
          this.parent_id = list[0].id;
        }
        
      });
    },
    getChildList(pid) {
      let child_lists = this.child_lists,
        child_ids = this.child_ids

      getFulianCate(pid).then(async (res) => {
        let list = res.data;
        console.log(list.length)
        if (list.length > 0) {
          child_lists.push(list);
          child_ids.push(list[0].id);
          this.getChildList(list[0].id)
        }
      });
    },
    chooseParent(id) {
      this.child_lists = [];
      this.child_ids = [];
      this.parent_id = id
      if(this.show_parent) this.show_parent = !this.show_parent
    },
    chooseChild(id, idx) {
      let child_lists = this.child_lists,
        child_ids = this.child_ids,
        list_length = child_lists.length;
      if (id == child_ids[idx]) return;
      child_lists.splice(idx, list_length - idx - 1);
      child_ids.splice(idx, list_length - idx - 1);
      child_ids[idx] = id;
      this.getChildList(id);
    },
    getArticleList: debounce(function () {
      let that = this;
      let q = {
        page: that.page,
        limit: that.limit
      };
      let parent_id = this.parent_id,
        child_ids = this.child_ids,
        pid = 0;
      if(this.parent_list.length<= 0 ) pid = this.pid;
      else if (child_ids.length == 0) pid = parent_id;
      else pid = child_ids[child_ids.length - 1]
      getArticleList(q, pid).then(res => {
        that.articleList = res.data.list;
        that.page_count = Math.ceil(res.data.count / that.limit);
      });
    }, 200),

    //上一页
    prePage: function () {
      let that = this;
      let page = that.page;
      page -= 1;
      page = page >= 1 ? page : 1;
      that.page = page;
      that.getArticleList();
    },
    nextPage: function () {
      let that = this;
      let page = that.page;
      let page_count = that.page_count;
      page += 1;
      page = page <= page_count ? page : page_count;
      that.page = page;
      that.getArticleList();
    },
    goDetail: function (id) {
      this.$router.push({ path: "/news_detail/" + id });
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #f3f3f3;
}

.cate-container {
  background-color: #fff;

  .parent-box {

    position: relative;
    border: solid #f3f3f3;
    border-width: 1px 0 1px 0;

    .parent-btn {
      position: absolute;
      right: 0;
      background-color: #fff;
      height: 100%;
      width: .76rem;
      line-height: 1rem;
      text-align: center;
      border-left: 1px solid #F3F3F3;
    }

    .parent-cate {
      width: 100vw;
      height: 1rem;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      padding-right: .76rem;


      .parent-item {
        display: inline-block;
        line-height: 1rem;
        font-size: .3rem;
        padding: 0 .25rem;

        &.active {
          color: #F64272;
          animation: jelly_scale .5s;
        }
      }
    }
  }

  .child-list {
    padding: 0 0 .2rem .1rem;
    display: flex;
    flex-wrap: wrap;
    animation: top_in .5s;

    .child-item {
      line-height: .53rem;
      min-width: 1.7rem;
      border-radius: .53rem;
      background-color: #f5f5f5;
      color: #434343;
      text-align: center;
      padding: 0 .1rem;
      font-size: .22rem;
      margin: .2rem 0 0 .1rem;

      &.active {
        background-color: #F64272;
        color: #fff;
      }
    }
  }
}


.news-list {
  background-color: #fff;
  padding: 0 .2rem;

  .news-item {
    display: flex;
    justify-content: space-between;
    padding: .3rem 0;

    &~.news-item {
      border-top: 1px solid #D2D2D2;
    }

    .news-title {
      font-size: .28rem;
    }

    .news-synopsis {
      font-size: .24rem;
      color: #B9BCBE;
    }

    .news-time {
      font-size: .22rem;
      color: #B9BCBE;
    }

    .news-img {
      flex-shrink: 0;
      margin-left: .2rem;

      img {
        width: 1.85rem;
        height: 1.43rem;
        vertical-align: bottom;
        object-fit: cover;
        border-radius: .1rem;
      }
    }
  }
}

.page-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .2rem 0;
  position: fixed;
  bottom: .5rem;
  width: 100%;
  left: 0;
  background-color: rgba($color: #F3F3F3, $alpha: .5);
}

.page-content .iconfont {
  font-size: .24rem;
  margin: 0 .4rem;
}

.area-window {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 556;
  width: 100vw;

  .window-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .3rem;
    font-size: .3rem;
    line-height: 1;
    border-bottom: 1px solid #EFEFEF;

    .cancel-btn {}

    .confirm-btn {
      color: #F64272;
    }
  }

  .area-container {
    height: 5rem;
    display: flex;

    .street-list {
      min-width: 2.77rem;
      background-color: #EFEFEF;
      flex-shrink: 0;
      height: 100%;
      overflow-y: auto;

      .street-item {
        line-height: 1rem;
        text-align: center;
        font-size: .3rem;

        &.active {
          background-color: #fff;
          color: #F64272;
        }
      }
    }

    .comm-list {
      flex: 1;
      padding-left: .5rem;
      height: 100%;
      overflow-y: auto;

      .comm-item {
        padding: .25rem 0;
        font-size: .3rem;
        line-height: 1;

        &.active {
          color: #F64272;
        }
      }
    }
  }
}

.nodata {
  text-align: center;
  font-size: .24rem;
  margin-top: 2rem;
}

.parent-window {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 556;
  width: 100%;
  border-radius: 0 0 .2rem .2rem;
  padding: 0 0 .3rem;
  display: flex;
  flex-wrap: wrap;
  animation: top_in .3s;

  .parent-item {
    min-width: 2.25rem;
    line-height: .72rem;
    border-radius: .1rem;
    background-color: #f5f5f5;
    text-align: center;
    padding: 0 .1rem;
    margin: .18rem 0 0 .18rem;
    font-size: .24rem;

    &.active {
      background-color: #F64272;
      color: #fff;
    }
  }
}
</style>
